import { Component, Input } from "@angular/core";

@Component({
  selector: "location-teams-details",
  templateUrl: "location-teams-details.html",
})
export class LocationTeamsDetails {
  @Input() companyTeam: any;

  constructor() {
    console.log("companyTeam:", this.companyTeam);
  }

  ngOnInit() {
    console.log("companyTeam ngOnInit:", this.companyTeam);
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/location-teams/location-teams-details/location-teams-details.ts